module.exports = __webpack_public_path__ + "img/245-aa3295.png";